<div class="exit-job mt-1 mb-4 p-3">
    <div class="row my-5">
      <div class="form-control-container col-span-12">
        {{message}}
      </div>
    </div>
</div>
